import React from 'react';

import { ClingSpiritImage } from './ClingSpiritImage';

import type { ClingCharacterDef } from '../../lib/melody/clingCharacterConfig';

import {

  SING_MAX_MIDI,

  SING_MIN_MIDI,

  SING_PITCHES,

} from '../../lib/melody/clingCantaConfig';



interface ClingConfigPitchGaugeProps {

  midi: number | null;

  micActive: boolean;

  detectedPitch: string | null;

  character: ClingCharacterDef;

}



function pitchPct(midi: number): number {

  return ((midi - SING_MIN_MIDI) / (SING_MAX_MIDI - SING_MIN_MIDI)) * 100;

}



export const ClingConfigPitchGauge: React.FC<ClingConfigPitchGaugeProps> = ({

  midi,

  micActive,

  detectedPitch,

  character,

}) => {

  const markerPct =

    midi != null

      ? Math.min(100, Math.max(0, pitchPct(midi)))

      : 50;



  return (

    <div className="cling-config-pitch-monitor" aria-label="Monitor de tono">

      <p className="cling-config-pitch-monitor-label">Tu tono</p>

      <div className="cling-config-pitch-gauge">

        <div className="cling-config-pitch-gauge-scale cling-config-pitch-gauge-scale--full">

          {SING_PITCHES.map((p) => {

            const active =

              detectedPitch === p.id ||

              (midi != null && Math.abs(midi - p.midi) < 1.25);

            return (

              <span

                key={p.id}

                className={`cling-config-pitch-gauge-mark ${active ? 'cling-config-pitch-gauge-mark--active' : ''}`}

              >

                {p.label}

              </span>

            );

          })}

        </div>

        <div className="cling-config-pitch-gauge-track">

          <div className="cling-config-pitch-gauge-grid" />

          {SING_PITCHES.map((p) => (

            <div

              key={`line-${p.id}`}

              className="cling-config-pitch-gauge-line"

              style={{ bottom: `${pitchPct(p.midi)}%` }}

            />

          ))}

          <div

            className={`cling-config-pitch-gauge-marker ${micActive ? 'cling-config-pitch-gauge-marker--on' : ''}`}

            style={{ bottom: `${markerPct}%` }}

          >

            <div className="cling-config-pitch-gauge-bird" style={{ filter: character.filter }}>

              <ClingSpiritImage size="lg" alt="" />

            </div>

          </div>

        </div>

      </div>

      <p className="cling-config-pitch-monitor-note">

        {detectedPitch ? detectedPitch : micActive ? 'Escuchando…' : 'Canta para ver tu nota'}

      </p>

    </div>

  );

};



export default ClingConfigPitchGauge;

